export const selectGameInvestmentType = (gameInvestments, investType, dateAdded) => {
   
    let historyExists = false;
    let transactionNbr = 0;
    let transactionArr = [];
    let historyTranArr = [];
    let taxHistoryArr = [];
    if (gameInvestments){
        const gameInvestmentRecord = 
            gameInvestments.find(elem => elem.investType === investType);
        if (gameInvestmentRecord){
            historyExists = gameInvestmentRecord.historyExists;
            historyTranArr = gameInvestmentRecord.historyTranArr;
            taxHistoryArr = gameInvestmentRecord.taxHistoryArr;
            dateAdded = gameInvestmentRecord.dateAdded;
            if (gameInvestmentRecord.transactionArr.length > 0){
                 // get the starting transNbr
                transactionArr = JSON.parse(JSON.stringify(gameInvestmentRecord.transactionArr));
                const maxIndx = transactionArr.length - 1;
                transactionNbr = +transactionArr[maxIndx].transNbr;
            }
        }
    }
    const returnObj = {historyExists: historyExists, transactionNbr: transactionNbr, 
        transactionArr: transactionArr, historyTranArr: historyTranArr, taxHistoryArr: taxHistoryArr,
        dateAdded: dateAdded}
    return returnObj;
}
export default selectGameInvestmentType;